import ResourceService from "./resource.service";

class FinancialReportsService extends ResourceService {
  static get resource() {
    return "financial-reports";
  }
}

export default FinancialReportsService;
